function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import { useMutation } from '@apollo/client';
import { getClientEnvironmentDetails } from '@sm/utils';
import { errorHandler as clientErrorHandler } from '../../../helpers/errorHandler';
import SaveTreatmentMutation from './SaveTreatment.graphql';
import { ExperimentAssignmentType } from '../../../types';
/**
 * If the user is LO and we have values from the Svc,
 * we can set a cookie for experimentsvc to injest
 * @param {Object} saveTreatmentPayload
 * @return {null}
 */
var createCookie = function createCookie(saveTreatmentPayload) {
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isBrowser = _getClientEnvironment.isBrowser;
  // no need to create a cookie if there isn't a cookie to create
  if (saveTreatmentPayload.success === false || !saveTreatmentPayload.name) {
    return null;
  }
  var name = saveTreatmentPayload.name,
    maxAge = saveTreatmentPayload.maxAge,
    assignments = saveTreatmentPayload.assignments;
  if (isBrowser) {
    var host = window.location.host;
    var domain = host.replace(/^[^.]+\./g, '');
    document.cookie = "".concat(name, "=").concat(assignments, "; max-age=").concat(maxAge, "; path=/; domain=").concat(domain);
  }
  return null;
};
var EXPERIMENT_ASSIGNMENT_TYPE_TO_SCHEMA = Object.freeze({
  NEW: ExperimentAssignmentType.New,
  EXISTING: ExperimentAssignmentType.Existing,
  WINNER: ExperimentAssignmentType.Winner
});
/**
 * Component to display a treatment
 * @param {String} when
 * @param {Object} treatments
 * @param {Boolean} control
 * @param {Function|Object} children
 * @returns {*}
 */
var Treatment = function Treatment(_ref) {
  var when = _ref.when,
    treatments = _ref.treatments,
    _ref$control = _ref.control,
    control = _ref$control === void 0 ? false : _ref$control,
    children = _ref.children;
  var _useMutation = useMutation(SaveTreatmentMutation),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    saveTreatment = _useMutation2[0];
  var childElement = typeof children === 'function' ? children() : children;
  var allTreatments = Object.keys(treatments);

  // If experiments fails, or the user hasn't been assigned and experiment show the control.
  if (allTreatments.length === 0 && control) {
    return childElement;
  }

  // if our treatment exists in the object
  if (allTreatments.length) {
    if (treatments[when] && treatments[when].treatmentName) {
      // send the data back to experiments that we are showing this treatment
      var _treatments$when = treatments[when],
        treatmentId = _treatments$when.treatmentId,
        experimentId = _treatments$when.experimentId,
        treatmentName = _treatments$when.treatmentName,
        experimentName = _treatments$when.experimentName,
        assignmentTypeString = _treatments$when.assignmentType;
      var assignmentType = EXPERIMENT_ASSIGNMENT_TYPE_TO_SCHEMA[assignmentTypeString];
      saveTreatment({
        variables: {
          input: {
            treatmentId: treatmentId,
            treatmentName: treatmentName,
            experimentId: experimentId,
            experimentName: experimentName,
            assignmentType: assignmentType
          }
        }
      }).then(function (_ref2) {
        var data = _ref2.data;
        if (data && data.saveExperimentTreatment) createCookie(data.saveExperimentTreatment);
      }).catch(function (e) {
        return (
          // TODO: Remove this cast when clientErrorHandler has been typed
          clientErrorHandler.logError(e, 'Unable to save experiment treatment')
        );
      });
      // Let's return the child element without waiting for the mutation as the
      // mutation doesn't really impact the children.
      return childElement;
    }
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default Treatment;
//# sourceMappingURL=index.js.map